import { render, staticRenderFns } from "./watchData.vue?vue&type=template&id=c3386aba&scoped=true"
import script from "./watchData.vue?vue&type=script&lang=js"
export * from "./watchData.vue?vue&type=script&lang=js"
import style0 from "./watchData.vue?vue&type=style&index=0&id=c3386aba&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3386aba",
  null
  
)

export default component.exports